import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Modal from "../../components/Modal";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import useLanguage from "../../utils/useLanguage";
import nextIcon from "../../assets/next_icon.png";
import previousIcon from "../../assets/previous_icon.png";
import editIcon from "../../assets/edit_icon.png";
import closeIcon from "../../assets/close_icon.png";
import saveIcon from "../../assets/save_icon.png";
import addIcon from "../../assets/add_icon.png";
import { UserAuth } from "../../utils/AuthContext";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import ErrorBox from "../../components/ErrorBox";
import { DataContext } from "../../utils/DataContext";
import BackToDashboard from "../../components/BackToDashboard";
import classes from "./CustomersPage.module.css";
import CustomCheckbox from "../../components/CustomCheckbox";
import ErrorMessage from "../../components/ErrorMessage";
import Dropdown from "../../components/Dropdown";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../../components/table-component/RoundedTable";
import TransactionsModal from "../../components/TransactionsModal";
import PaymentModal from "../../components/PaymentModal";
import PageHeadline from "../../components/PageHeadline";
import PageWrapper from "../../components/PageWrapper";

export default function CustomersPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  // const [networkError, setNetworkError] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerModal, setCustomerModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [customerFields, setCustomerFields] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  const [errorMessage2, setErrorMessage2] = useState("");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: filteredCustomers?.length,
  });

  const [loadingModal, setLoadingModal] = useState(false);

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [newCustomerFields, setNewCustomerFields] = useState({
    name: "",
    phoneNumber: null,
    email: null,
    address: null,
  });

  const [show2btns, setShow2btns] = useState(false);
  const [transactionsModal, setTransactionsModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [shouldGetCustomers, setShouldGetCustomers] = useState(false);

  const userId = parseInt(localStorage.getItem("userId"), 10);
  const organizationId = localStorage.getItem("organizationId");

  const { userData } = useContext(UserAuth);
  const {
    loading,
    setLoading,
    currencies,
    supplierCurrency,
    setSupplierCurrency,
  } = useContext(DataContext);

  useEffect(() => {
    const getAllCustomers = async () => {
      const req = await getCustomers();
    };

    getAllCustomers();
  }, [pagination.currentPage, searchTerm, userData]);

  // Get customers after (Payment, Repayment) from the customer modal
  useEffect(() => {
    if (!transactionsModal && shouldGetCustomers) {
      setShouldGetCustomers(false);
      getCustomers();
    }
  }, [transactionsModal, shouldGetCustomers]);

  const getCustomers = async (page, limit) => {
    const token =
      localStorage.getItem("SuperAdminToken") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("token");

    try {
      setLoading(true);
      const customers = await axios.get(
        `${process.env.REACT_APP_URL}/getCustomers`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
            "Organization-Id": organizationId,
          },
          params: {
            page: pagination.currentPage,
            limit: 5,
            search: searchTerm,
          },
        }
      );

      if (customers.data && customers.data.customers) {
        setCustomers(customers.data.customers);
        setFilteredCustomers(customers.data.customers);

        setPagination((prev) => ({
          ...prev,
          totalPages: customers.data.totalPages,
          totalRecords: customers.data.totalCustomers,
        }));
      } else {
        console.error("Failed to get the users");
      }
      if (!customers) {
        console.error("Failed to get the cusotmers", error);
      }

      const existingCustomers = customers?.data?.customers;

      setCustomers(existingCustomers);
      setLoading(false);

      if (existingCustomers.length) {
        setSelectedCustomer(existingCustomers[0]);
      }
    } catch (error) {
      // setNetworkError(true);
      setLoading(false);
      console.error("Failed to get the Customers", error);
    }
  };

  const fetchAllCustomers = async () => {
    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/getCustomers`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
            "Organization-Id": organizationId,
          },
          params: {
            page: 1,
            limit: pagination.totalRecords,
            search: searchTerm,
          },
        }
      );

      if (response.data && response.data.customers) {
        return response.data.customers;
      }
      return [];
    } catch (error) {
      console.error("Failed to get all customers", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setFilteredCustomers(
      customers.filter((customer) =>
        customer.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, customers]);

  const handleToggleTransactionsModal = (customer) => {
    setTransactionsModal((prev) => !prev);
    setSelectedCustomer(customer);
  };

  const handleTogglePaymentModal = (customer) => {
    setPaymentModal((prev) => !prev);
    setSelectedCustomer(customer);
  };

  const openCustomerModal = (customer) => {
    setSelectedCustomer(customer);
    setCustomerFields({
      name: customer.name,
      email: customer.email,
      phoneNumber: customer.phoneNumber,
      address: customer.address,
    });
    setIsEditing(false);
    setCustomerModal(true);
  };

  const titles = [
    { value: "customer" },
    { value: "totalAmount" },
    { value: "left" },
    { value: "received" },
    { value: "payment", keepOnMobile: true },
    { value: "transactions", keepOnMobile: true },
  ];

  const rows = filteredCustomers?.map((item) => [
    {
      value: <Link onClick={() => openCustomerModal(item)}>{item?.name}</Link>,
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
    {
      value: item.total,
      currency: t(item?.currency || "IQD"),
      type: TABLE_CELL_TYPES.MONEY,
    },
    {
      value: item.balance,
      currency: t(item?.currency || "IQD"),
      type: TABLE_CELL_TYPES.MONEY,
    },
    {
      value: item.received,
      currency: t(item?.currency || "IQD"),
      type: TABLE_CELL_TYPES.MONEY,
    },
    {
      value: (
        <CustomButton
          variant="green"
          // icon={addIcon}
          // iconSize={20}
          title={t("payment")}
          onClick={() => handleTogglePaymentModal(item)}
        />
      ),
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
    {
      value: (
        <CustomButton
          variant="blank"
          // icon={addIcon}
          // iconSize={20}
          title={t("transactions")}
          onClick={() => handleToggleTransactionsModal(item)}
        />
      ),
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
  ]);

  const validateName = (name) => {
    if (!name.trim()) {
      return t("inputFieldCannotBeEmpty");
    }
    if (name.length < 3) {
      return t("nameTooShort");
    }
    return "";
  };

  const handleContinue = () => {
    if (selectedCustomers.length === 0) {
      setErrorMessage2(t("selectAtLeastOneCustomer"));
    } else {
      setErrorMessage2("");
      goToMessagePage(selectedCustomers);
    }
  };

  const showTwoBtns = () => {
    setShow2btns(true);
    setShowCheckboxes(!showCheckboxes);
  };

  const cancel2Btns = () => {
    setShow2btns(false);
    setShowCheckboxes(!showCheckboxes);
    setErrorMessage2("");
  };

  const goToMessagePage = (selectedCustomers) => {
    // Ensure filteredCustomers is always an array
    const safeFilteredCustomers = Array.isArray(filteredCustomers)
      ? filteredCustomers
      : [];

    const customerNames = selectedCustomers.map((selected) => {
      const customerId = selected?.data?.id;

      const customer = safeFilteredCustomers.find(
        (customer) => customer.id === customerId
      );

      return customer ? customer.name : "Unknown";
    });

    navigate("/message-page", {
      state: {
        selectedCustomers: selectedCustomers,
        filteredCustomers: customerNames,
      },
    });
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setCustomerFields((prev) => ({
      ...prev,
      [fieldName]: value,
    }));

    if (fieldName === "name") {
      const error = validateName(value);
      setErrorMessage(error);
    } else {
      setErrorMessage("");
    }
  };
  const handleSaveCustomer = async () => {
    const token = localStorage.getItem("token");
    const userId = parseInt(localStorage.getItem("userId"), 10);
    const organizationId = parseInt(localStorage.getItem("organizationId"), 10);

    // Validate name field
    if (!customerFields.name?.trim()) {
      setErrorMessage(t("inputFieldCannotBeEmpty"));
      return; // Stop execution if validation fails
    }

    if (customerFields.name.length < 3) {
      setErrorMessage(t("nameTooShort")); // Replace with appropriate translation
      return;
    }

    try {
      setLoadingModal(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/updateCustomer/${selectedCustomer.id}`,
        {
          customerName: customerFields.name,
          phoneNumber: customerFields.phoneNumber,
          email: customerFields.email,
          address: customerFields.address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Organization-Id": organizationId,
          },
        }
      );

      if (response.data.message === "Customer updated successfully") {
        await getCustomers();
        setCustomerModal(false);
      } else {
        console.error("Failed to update Customer:", response.data.message);
      }
    } catch (error) {
      console.error("Error updating Customer:", error);
    } finally {
      setLoadingModal(false);
    }
  };

  const handleCancel = () => {
    setCustomerModal(false);
    setSelectedCustomer(null);
  };

  const openAddCustomerModal = () => {
    setAddCustomerModal(true);
    setNewCustomerFields({
      name: "",
    });
  };

  const handleNewCustomerInputChange = (e, fieldName) => {
    const value = fieldName === "isBlocked" ? e.target.checked : e.target.value;
    setNewCustomerFields((prevFields) => ({
      ...prevFields,
      [fieldName]: value,
    }));
  };

  const handleCreateCustomer = async (e) => {
    e.preventDefault();

    try {
      // Determine the language based on currentDirection
      const language = currentDirection === "rtl" ? "ar" : "en";

      //  Empty fields validation
      if (!newCustomerFields.name) {
        setError(true);
        setErrorMessage(t("emptyInputFields"));
        return;
      }

      // // Email validation regex
      // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // if (newUserFields.userEmail) {
      //   if (!emailPattern.test(newUserFields.userEmail)) {
      //     setError(true);
      //     setErrorMessage(t("invalidEmail"));
      //     return;
      //   }
      // }

      setLoadingModal(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/createCustomer`,
        {
          email: newCustomerFields.email,
          customerName: newCustomerFields.name,
          phoneNumber: newCustomerFields.phoneNumber,
          address: newCustomerFields.address,
          organizationId: Number(userData?.organizationId),
          userId: Number(userData?.userId),
          currency: supplierCurrency.value,
          language,
        }
      );

      setMessage(response.data.message);
      setPagination((prev) => ({
        ...prev,
        totalRecords: prev.totalRecords + 1,
      }));
      if (response.data.message === "Customer created successfully") {
        // Close the modal and refresh the user list
        setError(false);
        setErrorMessage("");
        setAddCustomerModal(false);
        await getCustomers();
      }
      setError(false);
      setErrorMessage("");
      setAddCustomerModal(false);
      setLoadingModal(false);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorKey = error.response.data.error;
        console.log("errorKey:", errorKey);
        // Map backend errors to user-friendly messages
        switch (errorKey) {
          case "emailAlreadyInUse":
          case "invalidPhoneNumber":
          case "customerAlreadyExist":
            setError(true);
            setErrorMessage(t(errorKey));
            break;
          default:
            setError(true);
            setErrorMessage(t("unexpectedError"));
            break;
        }
      } else {
        console.error("Network or other error:", error.message);
        setError(true);
        // setErrorMessage(t("networkError"));
      }
      setLoadingModal(false);
    }
  };

  const handleCancelAddCustomer = () => {
    setError(false);
    setErrorMessage("");
    setAddCustomerModal(false);
  };

  return (
    <div className="e-container">
      <PageWrapper
          style={{ direction: currentDirection }}
          title={t("organizations")}
          withBackButton
      >
        <div>
          <BackToDashboard
            title={t("back")}
            variant="blank-fit-content"
            icon={currentDirection === "ltr" ? previousIcon : nextIcon}
            iconSize={14}
            to={
              userData?.userType === "user"
                ? "/invoiceManagement"
                : `/${userData?.organizationType?.toLowerCase()}-dashboard`
            }
          />
        </div>

        {errorMessage2 && <ErrorBox>{errorMessage2}</ErrorBox>}

        <div className="o-row o-row--horizontal-align_space-between u-margin--top_700 u-margin--bottom_700">
          <PageHeadline title={"customers"} />

          {userData?.userId ? (
            <div className={classes.flexBtns}>
              <div className={classes.maxWidth}>
                <CustomButton
                  title={t("createCustomer")}
                  variant="blank"
                  icon={addIcon}
                  iconSize={20}
                  onClick={openAddCustomerModal}
                />
              </div>
              {show2btns ? (
                <div className={classes.flexRow}>
                  <CustomButton
                    title={t("cancel")}
                    variant="blank"
                    icon={closeIcon}
                    iconSize={15}
                    onClick={cancel2Btns}
                  />
                  <CustomButton
                    title={t("continue")}
                    iconSize={20}
                    onClick={handleContinue}
                    disabled={selectedCustomers.length ? false : true}
                  />
                </div>
              ) : (
                <CustomButton
                  title={t("contactCostumers")}
                  variant="blank"
                  iconSize={20}
                  onClick={showTwoBtns}
                  // onClick={handleContinue}
                />
              )}
            </div>
          ) : null}
        </div>
        <CustomInput
          name="name"
          value={searchTerm}
          placeholder={searchTerm ? "" : t("search")}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {loading ? (
          <Loader />
        ) : filteredCustomers.length === 0 ? (
          <p>{t("noCustomersFound")}</p>
        ) : (
          <ul className="users-list">
            {errorMessage2 && <ErrorMessage>{errorMessage2}</ErrorMessage>}

            <RoundedTable
              withCheckbox={show2btns}
              titles={titles}
              rows={rows}
              fullData={filteredCustomers}
              pagination={pagination}
              setPagination={setPagination}
              selectedRows={selectedCustomers}
              setSelectedRows={setSelectedCustomers}
              onSelectAll={fetchAllCustomers}
            />
          </ul>
        )}

        {/* Edit customer Modal */}
        {customerModal && (
          <Modal
            title={isEditing ? t("editCustomer") : t("customer")}
            onClose={handleCancel}
            footer={
              <>
                {loadingModal ? <Loader /> : null}
                <section className="edit-user-actions">
                  {isEditing ? (
                    <>
                      <CustomButton
                        onClick={handleSaveCustomer}
                        title={t("confirm")}
                        icon={saveIcon}
                        iconSize={16}
                        disabled={loadingModal}
                      />
                      <CustomButton
                        title={t("cancel")}
                        onClick={handleCancel}
                        variant="blank"
                        icon={closeIcon}
                        iconSize={14}
                      />
                    </>
                  ) : (
                    <>
                      {userData?.userId ? (
                        <CustomButton
                          variant="blank"
                          title={t("edit")}
                          onClick={() => setIsEditing(true)}
                          icon={editIcon}
                          iconSize={18}
                        />
                      ) : null}
                    </>
                  )}
                </section>
              </>
            }
          >
            {error && <ErrorBox>{errorMessage}</ErrorBox>}
            <div>
              <section>
                <div>
                  {isEditing ? (
                    <div className="edit-user-entity">
                      <span>{t("customerName")}: </span>
                      <CustomInput
                        name="name"
                        value={customerFields.name || ""}
                        onChange={(e) => handleInputChange(e, "name")}
                        errorText={
                          errorMessage ? t("inputFieldCannotBeEmpty") : ""
                        }
                      />{" "}
                    </div>
                  ) : (
                    <div className="view-user-entity">
                      <p variant="body1">{t("customerName")}:</p>
                      <p variant="body1">{selectedCustomer?.name}</p>
                    </div>
                  )}
                </div>
              </section>
              <section>
                <div>
                  {isEditing ? (
                    <div className="edit-user-entity">
                      <span>{t("email")}: </span>
                      <CustomInput
                        name="email"
                        value={customerFields.email || ""}
                        onChange={(e) => handleInputChange(e, "email")}
                      />{" "}
                    </div>
                  ) : (
                    <div className="view-user-entity">
                      <p variant="body1">{t("email")}:</p>
                      <p variant="body1">{selectedCustomer?.email}</p>
                    </div>
                  )}
                </div>
              </section>
              <section>
                <div>
                  {isEditing ? (
                    <div className="edit-user-entity">
                      <span>{t("phoneNumber")}: </span>
                      <CustomInput
                        name="phoneNumber"
                        value={customerFields.phoneNumber || ""}
                        onChange={(e) => handleInputChange(e, "phoneNumber")}
                      />{" "}
                    </div>
                  ) : (
                    <div className="view-user-entity">
                      <p variant="body1">{t("phoneNumber")}:</p>
                      <p variant="body1">{selectedCustomer?.phoneNumber}</p>
                    </div>
                  )}
                </div>
              </section>
              <section>
                <div>
                  {isEditing ? (
                    <div className="edit-user-entity">
                      <span>{t("address")}: </span>
                      <CustomInput
                        name="address"
                        value={customerFields.address || ""}
                        onChange={(e) => handleInputChange(e, "address")}
                      />{" "}
                    </div>
                  ) : (
                    <div className="view-user-entity">
                      <p variant="body1">{t("address")}:</p>
                      <p variant="body1">{selectedCustomer?.address}</p>
                    </div>
                  )}
                </div>
              </section>
              <section>
                <div>
                  <div className="view-user-entity">
                    <p variant="body1">{t("usedCurrency")}:</p>
                    <p variant="body1">{selectedCustomer?.currency}</p>
                  </div>
                </div>
              </section>
            </div>
          </Modal>
        )}

        {/* Add Customer Modal */}
        {addCustomerModal && (
          <Modal
            title={t("createCustomer")}
            onClose={handleCancelAddCustomer}
            withDropdown
            footer={
              <>
                {loadingModal ? <Loader /> : null}
                <section className="edit-user-actions">
                  <CustomButton
                    title={t("confirm")}
                    onClick={handleCreateCustomer}
                    icon={saveIcon}
                    iconSize={16}
                    disabled={loadingModal}
                  />
                  <CustomButton
                    title={t("cancel")}
                    onClick={handleCancelAddCustomer}
                    variant="blank"
                    icon={closeIcon}
                    iconSize={14}
                  />
                </section>
              </>
            }
          >
            <form onSubmit={handleCreateCustomer}>
              <div>
                {error && (
                  <div className="o-row o-row--horizontal-align_center o-row--vertical-align_center">
                    <ErrorBox>{errorMessage}</ErrorBox>
                  </div>
                )}
                <div className="edit-user-entity">
                  <span>{t("customerName")}: </span>
                  <CustomInput
                    name="name"
                    value={newCustomerFields.name}
                    onChange={(e) => handleNewCustomerInputChange(e, "name")}
                    errorText={errorMessage ? t("inputFieldCannotBeEmpty") : ""}
                  />
                  <span>{t("email")}: </span>
                  <CustomInput
                    name="email"
                    value={newCustomerFields.email}
                    onChange={(e) => handleNewCustomerInputChange(e, "email")}
                  />
                  <span>{t("phoneNumber")}: </span>
                  <CustomInput
                    name="phoneNumber"
                    value={newCustomerFields.phoneNumber}
                    onChange={(e) =>
                      handleNewCustomerInputChange(e, "phoneNumber")
                    }
                  />
                  <span>{t("address")}: </span>
                  <CustomInput
                    name="address"
                    value={newCustomerFields.address}
                    onChange={(e) => handleNewCustomerInputChange(e, "address")}
                  />

                  <span>{t("usedCurrency")}: </span>
                  <Dropdown
                    options={currencies}
                    selected={supplierCurrency}
                    setSelected={setSupplierCurrency}
                    flex
                  />
                </div>
              </div>
            </form>
          </Modal>
        )}

        {transactionsModal ? (
          <TransactionsModal
            selected={selectedCustomer}
            handleToggleTransactionsModal={handleToggleTransactionsModal}
            withSubCompany
            setShouldGetCustomers={setShouldGetCustomers}
          />
        ) : null}

        {paymentModal ? (
          <PaymentModal
            selected={selectedCustomer}
            handleTogglePaymentModal={handleTogglePaymentModal}
            withSubCompany
            refetchData={getCustomers}
            setShouldGetCustomers={() => null}
          />
        ) : null}
      </PageWrapper>
    </div>
  );
}
